import Glider from '../../../js/glider'

require('./_full-image-carousel.scss')
require('../../../js/glider')
const MARGIN_BOTTOM = 35
const FullImageCarousel = {

  init: function (element) {
    const _ = this
    const gliderElement = element.querySelector('.glider')
    const slideCount = element.querySelectorAll('.full-image-carousel__item').length

    if (slideCount === 1) {
      // disable carousel if only one slide
      // also hides buttons via css
      element.classList.add('no-carousel')
      return
    }

    const autoplayEnabled = element.classList.contains('autoplay')

    if (autoplayEnabled === true) {
      // autoplayDuration value in seconds
      const autoplayDuration = element.attributes['data-autoplay-duration'].value * 1000

      if (autoplayDuration > 0) {
        // bind glider-slide-visible event only if autoplayEnabled is true and autoplayDuration > 0
        gliderElement.addEventListener('glider-loaded', (event) => {
          gliderElement.setAttribute('data-current-slide', 0)
          let interval = null
          interval = _.startSlideshow(gliderElement, autoplayDuration, interval, _)
          const pauseButton = element.querySelector('.carousel__button--pause')
          if (pauseButton !== null) {
            pauseButton.classList.add('playing')
            pauseButton.addEventListener('click', (e) => { _.pauseSlideshow_toggle(e.currentTarget, gliderElement, autoplayDuration, interval, _) })
          }
        })
      }
    }

    const glider = new Glider(gliderElement, {
      slidesToShow: 1,
      slidesToScroll: 1,
      rewind: true,
      draggable: true,
      scrollLock: true,
      resizeLock: true,
      dots: element.querySelector('.dots'),
      arrows: {
        prev: element.querySelector('.glider-prev'),
        next: element.querySelector('.glider-next')
      }
    })

    glider.playPause = element.querySelector('.carousel__button--pause')

    window.addEventListener('load', function () {
      _.centerNavigation(glider)
    })

    gliderElement.addEventListener('glider-animated', function (e) {
      _.centerNavigation(glider)
    })

    gliderElement.addEventListener('glider-refresh', function (e) {
      _.centerNavigation(glider)
    })
  },

  centerNavigation: function (glider) {
    const arrows = glider.arrows
    const dots = glider.dots
    const playPause = glider.playPause
    const image = glider.ele.querySelector('.glider-slide.active .full-image-carousel__item-image')
    const height = image.offsetHeight + MARGIN_BOTTOM

    if (glider.ele) {
      glider.ele.parentElement.style.setProperty('--image-height', height + 'px')
    }

    if (arrows) {
      ['prev', 'next'].forEach(function (v) {
        if (arrows[v]) {
          arrows[v].style.top = (height / 2) + 'px'
        }
      })
    }

    if (dots) {
      dots.style.bottom = 'auto'
      dots.style.top = (height - dots.offsetHeight) + 'px'
    }

    if (playPause) {
      playPause.style.bottom = 'auto'
      playPause.style.top = (height - playPause.offsetHeight) + 'px'
    }
  },
  startSlideshow: (gliderElement, autoplayDuration, interval, _) => {
    interval = setInterval(() => { _.playNextSlide(gliderElement) }, autoplayDuration)
    return interval
  },
  pauseSlideshow: (_, interval) => {
    window.clearInterval(interval)
  },
  playNextSlide: (gliderElement) => {
    const glider = Glider(gliderElement)

    let nextSlide = glider.slide + 1
    if (glider.slides[glider.slides.length - 1].classList.contains('visible')) {
      nextSlide = 0
    }

    glider.scrollItem(nextSlide)
    gliderElement.setAttribute('data-current-slide', nextSlide)
  },
  pauseSlideshow_toggle: (el, gliderElement, autoplayDuration, interval, _) => {
    if (_.IsAutoplayPaused(gliderElement)) {
      _.playNextSlide(gliderElement)
      _.startSlideshow(gliderElement, autoplayDuration, interval, _)
      el.classList.remove('paused')
      el.classList.add('playing')
      el.attributes['aria-label'].value = 'Pause slideshow'
    } else {
      _.pauseSlideshow(_, interval)
      el.classList.remove('playing')
      el.classList.add('paused')
      el.attributes['aria-label'].value = 'Play slideshow'
    }
  },
  IsAutoplayPaused: (gliderElement) => {
    const glider = Glider(gliderElement)
    return glider.playPause.classList.contains('paused')
  }
}

export default FullImageCarousel
